<template>
  <div :class="[ 'file-input', { 'user-error': showErrors && !this.filename }]">
    <input type="file" id="file"
           accept="image/*,.pdf"
           @change="update"
           ref="input" />
    <label for="file">
      <span class="button button--medium button--primary">{{ translate('btnSelectFile') }}</span>
      <span class="caption" :title="filename" v-text="filename"></span>
      <button v-if="filename"
              type="button" class="button--clear"
              @click.prevent="clear"
      ><svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 64 64"><path fill="none" stroke-miterlimit="10" stroke-width="4" d="M9.37 9.37l45.26 45.26M9.37 54.63L54.63 9.37"/></svg></button>
    </label>
  </div>
</template>

<script>
export default {
  name: 'FileInput',
  data: () => ({
    filename: '',
    file: null,
  }),
  props: {
    showErrors: Boolean,
  },
  methods: {
    update(event) {
      const files = event?.target?.files;
      if (files.length > 0) {
        this.filename = event.target.value.split('\\').pop();
        [this.file] = files;
      } else {
        this.file = null;
      }
      this.$emit('change', this.file);
    },
    clear() {
      this.filename = '';
      this.file = null;
      this.$refs.input.value = null;
      this.$emit('change', this.file);
    },
  },
};
</script>

<style lang="scss">
.collect-seedpoints-form .file-input {
  //width: 100%;

  input[type='file'] {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
    flex-shrink: 0;
  }
  label {
    //width: 100%;
    display: flex;
    justify-content: stretch;

    .button {
      flex-shrink: 0;
    }

    .caption {
      flex-grow: 1;
      background-color: $color-white;
      color: $color-kws-gray-75;
      padding-left: rem(10px);
      line-height: rem(42px);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .button--clear {
      border: 0;
      padding: rem(10px);
      text-align: center;
      background-color: $color-white;
      color: $color-kws-gray-75;
      flex-shrink: 0;

      svg {
        width: rem(24px);
        height: auto;
        stroke: currentColor;
      }
    }
  }
}
</style>
